import ben from "./images/Benoudi.jpg"
import "./../index.css"
function Image({key}) {
  

    return(<div > 
        <figure className="md:flex bg-slate-900 rounded-xl p-6 md:p-0 text-size-adjust:auto">
        <img  id="image" className="imagenasser" src={ben} alt="" width="384" height="512" />
      
      <div className="pt-4 md:p-6 text-center md:text-left space-y-2">

        <figcaption className="font-medium">
          <div className="text-sky-500 dark:text-sky-400 ">
            Nasser Benoudi 
          </div>
          <div className="text-slate-300 dark:text-slate-50 ">
           <p className="zwichen">Computer science teacher and DevOps programmer</p> Java-Spring-boot and Javascript-React.
         
         
          
          </div>
        </figcaption>
      </div>
    </figure></div>)
}

export default Image;